import FeesSlider  from '../FeesSlider';

const Prices = ({ feesNotes, title, subTitle, children }) => {
  return (
    <div className="fees__container">
      <h2>{title}</h2>
      <p className="subtitle_1">{subTitle}</p>
      <div className="fees-cards">
        {feesNotes.map(({ heading, paragraph }) => {
          return (
            <div className="fee-card">
              <div className="fee-card__image image-placeholder" />
              <h3>{heading}</h3>
              <p>{paragraph}</p>
            </div>
          );
        })}
      </div>
      <FeesSlider />
      {children}
    </div>
  );
};

export default Prices;
